export default __webpack_public_path__ + "static/pokitpal-logo-d495b34600c767eb67a16b0e666604cc.png";